module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么不能引入全部组件")]), _vm._v(" "), _c('p', [_vm._v("移动端引入全部组件会导致体积过大，加载速度慢，浪费用户等待时间并且浪费(cdn)带宽。")]), _vm._v(" "), _c('p', [_vm._v("另一方面随着组件库迭代，组件数量增加，这个体积会逐渐变得不可接受。")]), _vm._v(" "), _c('p', [_vm._v("因此 "), _c('code', [_vm._v("VUX")]), _vm._v(" 没有像其他组件库一样直接提供全部引入的使用方式，按需使用是最佳实践。")]), _vm._v(" "), _c('p', [_vm._v("如果你只是不想每次在单个 "), _c('code', [_vm._v(".vue")]), _vm._v(" 文件里重复地 "), _c('code', [_vm._v("import")]), _vm._v("，那么你可以直接在 "), _c('code', [_vm._v("main.js")]), _vm._v(" 里进行全局注册。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Group, Cell } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'group'")]), _vm._v(", Group)\nVue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'cell'")]), _vm._v(", Cell)\n")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_c('code', [_vm._v("VUX@3.0")]), _vm._v(" 将会实现无声明使用组件。")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ffc1052", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-5ffc1052"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/why-cannot-i-import-all-components-25.vue
// module id = 2794
// module chunks = 196